import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
// import arrow from '../../images/icons8-down.svg';

class RenderNameHeader extends Component {
  render() {
    return(
      <Grid 
        container
        className={'relative pt2 pb2 tc'}>
        <Grid 
          item 
          xs={2}
          sm={2}
          className="name-hack title tl fw5 pr3-ns pr0">
          <span className={'relative dn db-ns tc'}>
            Rank
          </span>
          <span className={'relative db dn-ns'}>
            #
          </span>
        </Grid>
        <Grid
          item
          xs={10}
          sm={2}
           className="fw5 tl tc-ns pl0">
          {this.props.headerArgs.label}
        </Grid>
      </Grid>
    )
  }
}

RenderNameHeader.propTypes = {
  headerArgs: PropTypes.object.isRequired,
  activeSort: PropTypes.number,
  updateSort: PropTypes.func.isRequired
}

export default RenderNameHeader;